import axios from 'axios';

let prefix = "/farming-skill-element"

const FarmingSkillElementApi = {
	listFarmingSkillElement(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getFarmingSkillElementInfo(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	getFarmingSkillElementByUniqueId(payload) {
		return axios.get(prefix + "/get-by-unique-id", { params: payload })
	},
	getElementTypes(payload) {
		return axios.get(prefix + "/element-types", { params: payload })
	},
	archiveFarmingSkillElement(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createFarmingSkillElement(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateFarmingSkillElement(payload) {
		return axios.post(prefix + "/update", payload)
	},
}

export default FarmingSkillElementApi;
